import React from "react";
import Weather from "./Weather";
import "./App.css";

export default function App() {
  return (
    <div className="App">
      <div className="container">
        <Weather defaultCity="New York" />

        <footer>
          This project was coded by{" "}
          <a
            href="https://www.linkedin.com/in/mariia-glazunova/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Mariia Glazunova
          </a>{" "}
          and is{" "}
          <a
            href="https://github.com/Mariia-cioccolatini/react-weather-app-new"
            target="_blank"
            rel="noopener noreferrer"
          >
            open-sourced on GitHub
          </a>{" "}
          and{" "}
          <a
            href="https://magenta-sunflower-96ef9d.netlify.app/"
            target="_blank"
            rel="noopener noreferrer"
          >
            hosted on Netlify
          </a>
        </footer>
      </div>
    </div>
  );
}
